import type { Data } from '@/api/api.ts'
import type { TechMessageNotification } from '@/types/types.ts'
import axios from 'axios'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}cabmessage/`

export const getTechSupportMessagesCount = async (): Promise<Data<TechMessageNotification>> =>
  axios.get(`${urlPrefix}chats/count/`)

export const getGlobalNotifications = async (): Promise<any> => axios.get(`${urlPrefix}allert/`)

export const deleteGlobalNotification = async (id: number): Promise<any> =>
  axios.get(`${urlPrefix}allert/notification/${id}/close/`)
